import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-start-letter-of-credit',
  templateUrl: './start-letter-of-credit.component.html',
  styleUrls: ['./start-letter-of-credit.component.scss']
})
export class StartLetterOfCreditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
